import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/layouts/default.vue").then(m => m.default || m)),
  project: defineAsyncComponent(() => import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/layouts/project.vue").then(m => m.default || m))
}